import { UrlHelper } from 'utilities/UrlHelper/UrlHelper';

import { Environment } from 'Environment';

const RPCModel = require('RPCModel');

const MarketplaceProject = RPCModel.extend({
    className: 'MCS.Marketplace',

    addUrl: 'projects/:pid/services/marketplace',
    findOneUrl: 'projects/:pid/services/marketplace',

    defaults: {
        id: undefined,
    },

    parse(body) {
        body.id = 0;

        return body;
    },

    prepareSendData() {
        return {
            metrics: Environment.utmParams,
        };
    },
});

MarketplaceProject.url = UrlHelper.getModelUrlPidInjector();

export default MarketplaceProject;
